module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/fb_share-73a5063ceb4048a947bf3693b6de4c06.jpg";